import React, { useState } from "react";
import { ModalTask } from "./ModalTask";

export const BtnThemMoi = ({ onReload, disabled }) => {
    const [show, setShow] = useState(false);
    return (
        <>
            <button type="button" className="btn btn-border-new" onClick={() => setShow(true)} disabled={disabled}>
                <span>
                    <img
                        src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                        style={{ paddingBottom: "5px", marginRight: '6px' }}
                        alt="Thêm mới"
                    />
                    Thêm mới
                </span>
            </button>
            {show && <ModalTask mode="create" show={show} onHide={() => setShow(false)} onSaved={() => { setShow(false); onReload(); }} />}
        </>
    );
};